import { render, staticRenderFns } from "./EditImageNavigation.vue?vue&type=template&id=bde6db46&scoped=true&"
import script from "./EditImageNavigation.vue?vue&type=script&lang=ts&"
export * from "./EditImageNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./EditImageNavigation.vue?vue&type=style&index=0&id=bde6db46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde6db46",
  null
  
)

export default component.exports